import dayjs from "dayjs";
import { clinicId, createdById, userType } from "../../../constants";

export type InvestigationDropDownType = {
  cptId: number;
  cptCode: string;
  cptName: string;
  cptDes: string;
  cptRate: number;
  cptGroupId: number;
  insCoverage: number;
  isExclude?: number;
  approvalRequired?: number;
  isFavorite?: number;
};

export type InvestigationFormType = {
  cpt: InvestigationDropDownType | null;
  Rate: number;
  Quantity: string;
  amount: number;
  patientshare: number;
  outHouse: boolean;
  approvalRequired: boolean;
  IsPerfomed: boolean;
  Reason: string;
  Remark: string;
  encounterId: string;
  radiologyId: number;
  isExcluded: boolean;
  createdDate?: string | Date;
  insuranceCoverage?: number | boolean;
  fromVerification?: boolean;
  discount?: number;
  discountType?: string;
  insDiscount?: number;
  actualPatshare?: number | null;
};

export type LabType = {
  labDetailsId: number | null;
  cptId: number;
  labDetailsQty: number;
  labDetailsAmt: number;
  labDetailsInsDiscount: number;
  labDetailsInsAmount: number;
  labDetailsPshare: number;
  labDetailsOutHouse: boolean;
  labDetailsApproval: boolean;
  labDetailsIsPerformed: boolean;
  labDetailsRemarks: string;
  labDetailsReason: string;
  labDetailsStatus: number;
  labDetailsCreatedId: number;
  labDetailsCreatedDate: string | null;
  labDetailsClinicId: number;
  isModified: number;
  isBilled: number;
  userType: number;
  hl7MsgStatus: number;
  unitRate: number;
  revertFlag: boolean;
  labRefNo: number | null;
  isExcluded: boolean;
  isPackage: number;
  insCoverage: number;
  encounterId: number;
  paymentMode: number;
  discountType: string;
  discountAmount: number | null;
  discountPercentage: number | null;
  actualPatshare?: number | null;
};

export type RadiologyType = {
  radiologyDetailsId: number | null;
  cptId: number;
  radiologyDetailsQty: number;
  radiologyDetailsAmt: number;
  radiologyDetailsInsDiscount: number;
  radiologyDetailsInsAmount: number;
  radiologyDetailsPshare: number;
  actualPatshare?: number | null;
  radiologyDetailsOutHouse: boolean;
  radiologyDetailsApproval: boolean;
  radiologyDetailsIsPerformed: boolean;
  radiologyDetailsRemarks: string;
  radiologyDetailsReason: string;
  radiologyDetailsStatus: number;
  radiologyDetailsCreatedById: number;
  radiologyDetailsCreatedByDate: string | null;
  radiologyDetailsClinicId: number;
  isModified: number;
  userType: number;
  isBilled: number;
  unitRate: number;
  revertFlag: boolean;
  isExcluded: boolean;
  insCoverage: number;
  encounterId: number;
  paymentMode: number;
  isPackage?: number;
  discountType: string;
  discountAmount: number | null;
  discountPercentage: number | null;
};

export type GetLabPayloadType = {
  encounterId: number;
  status?: number;
};

export type LabTableType = {
  userType: number;
  isModified: number;
  unitRate: number;
  cptRate?: number;
  isBilled: number;
  labDetailsId: number;
  labDetailsQty: number;
  labDetailsAmt: number;
  isPackage: boolean;
  insCoverage: number;
  labDetailsReason: string;
  labDetailsOutHouse: boolean;
  labDetailsInsAmount: number;
  labDetailsInsDiscount: number;
  labDetailsIsPerformed: boolean;
  labDetailsRemarks: string;
  labDetailsStatus: number;
  labDetailsPshare: number;
  labDetailsApproval: boolean;
  labCptCode: string;
  labCptName: string;
  labCptDes: string;
  labCptId: number;
  isExcluded: boolean;
  createdDate?: string;
  createdByDate?: string;
  discountAmount: number | null;
  discountPercentage: number | null;
  discountType: string;
};

export type RadiologyTableType = {
  radiologyDetailsInsDiscount: number;
  radiologyDetailsApproval: boolean;
  radiologyDetailsInsAmount: number;
  radiologyDetailsOutHouse: boolean;
  radiologyDetailsIsPerformed: boolean;
  cptCode: string;
  cptRate?: number;
  cptName: string;
  cptDes: string;
  isModified: number;
  userType: number;
  insCoverage: number;
  isExcluded: boolean;
  unitRate: number;
  isBilled: number;
  radiologyDetailsId: number;
  radiologyDetailsQty: number;
  radiologyDetailsAmt: number;
  radiologyDetailsPshare: number;
  radiologyDetailsRemarks: string;
  radiologyDetailsStatus: number;
  radiologyDetailsReason: string;
  cptId: number;
  createdDate?: string;
  createdByDate?: string;
  discountAmount: number | null;
  discountPercentage: number | null;
  discountType: string;
};

export const prepareRadiologyPayload = (
  data: InvestigationFormType & {
    paymentMode: number;
    fromVerification?: boolean;
  },
): RadiologyType => {
  return {
    radiologyDetailsId: Boolean(data?.radiologyId) ? data?.radiologyId : null,
    cptId: data.cpt?.cptId as number,
    radiologyDetailsQty: Number(data?.Quantity || 0),
    radiologyDetailsAmt: Number(data?.Rate || 0) * Number(data?.Quantity || 0),
    radiologyDetailsInsDiscount: Number(data?.insDiscount || 0),
    radiologyDetailsInsAmount:
      data?.paymentMode == 1 && data?.insuranceCoverage != 0
        ? Number(data.patientshare)
        : 0,
    radiologyDetailsPshare: Number(data?.patientshare || 0),
    radiologyDetailsOutHouse: Boolean(data?.outHouse),
    radiologyDetailsApproval: Boolean(data?.approvalRequired),
    radiologyDetailsIsPerformed: Boolean(data?.IsPerfomed),
    radiologyDetailsRemarks: data?.Remark || "",
    radiologyDetailsReason: data?.Reason || "",
    radiologyDetailsStatus: 1,
    radiologyDetailsCreatedById: createdById as number,
    radiologyDetailsCreatedByDate: data?.createdDate
      ? dayjs(data?.createdDate).format("YYYY-MM-DDTHH:mm:ss")
      : null,
    radiologyDetailsClinicId: clinicId,
    isModified: 0,
    userType: userType,
    isBilled: 0,
    unitRate: data?.Rate,
    revertFlag: true,
    isExcluded: Boolean(data?.isExcluded),
    insCoverage: data.insuranceCoverage
      ? Number(data.insuranceCoverage)
      : data?.cpt?.insCoverage || 0,
    encounterId: Number(data?.encounterId || "0"),
    paymentMode: data.paymentMode,
    isPackage: 0,
    discountType: String(data?.discountType),
    discountAmount:
      data?.discountType == "Percentage" ? null : Number(data?.discount),
    discountPercentage:
      data?.discountType == "Percentage" ? Number(data?.discount) : null,
    actualPatshare:
      data?.actualPatshare === undefined || data?.actualPatshare === null
        ? null
        : Number(data.actualPatshare),
  };
};

export const prepareLabPayload = (
  data: InvestigationFormType & {
    paymentMode: number;
    fromVerification?: boolean;
  },
): LabType => {
  // let labDetailsInsAmount = Number(Number(data.amount).toFixed(2))
  return {
    labDetailsId: Boolean(data?.radiologyId) ? data?.radiologyId : null,
    cptId: data.cpt?.cptId as number,
    labDetailsQty: Number(data?.Quantity),
    labDetailsAmt: Number(data.Rate || "0") * Number(data?.Quantity || "0"),
    labDetailsInsDiscount: Number(data?.insDiscount || 0),
    labDetailsInsAmount:
      data?.paymentMode == 1 && data?.insuranceCoverage != 0
        ? Number(data?.patientshare || 0)
        : 0,
    labDetailsPshare: Number(data?.patientshare || 0),
    labDetailsOutHouse: Boolean(data?.outHouse),
    labDetailsApproval: Boolean(data?.approvalRequired),
    labDetailsIsPerformed: Boolean(data?.IsPerfomed),
    labDetailsRemarks: data?.Remark || "",
    labDetailsReason: data?.Reason || "",
    labDetailsStatus: 1,
    labDetailsCreatedId: createdById as number,
    labDetailsCreatedDate: data?.createdDate
      ? dayjs(data?.createdDate).format("YYYY-MM-DDTHH:mm:ss")
      : null,
    labDetailsClinicId: clinicId,
    isModified: 0,
    isBilled: 0,
    userType: userType,
    hl7MsgStatus: 0,
    unitRate: Number(data?.Rate || 0),
    revertFlag: true,
    labRefNo: null,
    isExcluded: Boolean(data?.isExcluded),
    isPackage: 0,
    insCoverage: data.insuranceCoverage
      ? Number(data.insuranceCoverage)
      : Number(data?.cpt?.insCoverage),
    encounterId: parseInt(data.encounterId),
    paymentMode: data.paymentMode,
    discountType: String(data?.discountType),
    discountAmount:
      data?.discountType == "Percentage" ? null : Number(data?.discount),
    discountPercentage:
      data?.discountType == "Percentage" ? Number(data?.discount) : null,
    actualPatshare:
      data?.actualPatshare === undefined || data?.actualPatshare === null
        ? null
        : Number(data.actualPatshare),
  };
};

export const investigationDefaultValues: InvestigationFormType = {
  cpt: null,
  Rate: 0,
  Quantity: "",
  amount: 0,
  patientshare: 0,
  outHouse: false,
  approvalRequired: false,
  IsPerfomed: false,
  Reason: "",
  Remark: "",
  encounterId: "",
  radiologyId: 0,
  isExcluded: false,
  discount: 0,
  discountType: "Percentage",
};

export type CptInvestigationRateType = {
  insRate: number | null;
  isExcluded: boolean | null;
  approvalRequired: boolean | null;
  cptId?: number | null;
  cptGroupID?: string | null;
  cptName?: string | null;
};

export type GetPatientShareParams = {
  cptId: number;
  amount: number;
  qty: number;
  encounter: number;
  cptGroupId: number;
  id: number;
  clinicId: number;
  editFlag: number;
};

export type GetPatientResponse = {
  rate: number;
  qty: number;
  amount: number;
  patShare: number;
  insDiscount: number;
  insAmount: number;
};
